import btc from './btc.svg'
import eth from './eth.svg'
import bnb from './bnb.svg'
import matic from './matic.svg'
import arbeth from './arbeth.svg'
import aureth from './aureth.svg'
import xdai from './xdai.svg'
import ftm from './ftm.svg'
import avax from './avax.svg'
import movr from './movr.svg'
import one from './one.svg'
import wbtc from './wbtc.svg'
import icx from './icx.svg'
import waves from './waves.svg'
import xrp from './xrp.svg'
import swap from './swap.svg'
import usdt from './usdt.svg'
import syc2 from './syc2.svg'
import drt from './drt.svg'
import omg from './omg.svg'
import yup from './yup.svg'
import kn from './kn.svg'
import arn from './arn.svg'
import lev from './lev.svg'
import bxb from './bxb.svg'
import dcn from './dcn.svg'
import pay from './pay.png'
import eurs from './eurs.svg'
import ghost from './ghost.svg'
import next from './next.svg'
import phi from './phi.png'


export default {
  btc,
  'btc (multisig)': btc,
  'btc (sms-protected)': btc,
  'btc (pin-protected)': btc,
  wbtc,
  dcn,
  bxb,
  kn,
  drt,
  lev,
  arn,
  omg,
  eth,
  bnb,
  matic,
  arbeth,
  aureth,
  xdai,
  ftm,
  avax,
  movr,
  one,
  syc2,
  icx,
  usdt,
  swap,
  waves,
  xrp,
  yup,
  pay,
  eurs,
  ghost,
  next,
  phi,
}
